import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Encyclopedia from "../pages/encyclopedia/page";
import Works from "../pages/works/page";
import CharacterDetail from "../pages/character/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/encyclopedia",
    element: <Encyclopedia />,
  },
  {
    path: "/works",
    element: <Works />,
  },
  {
    path: "/character/:slug",
    element: <CharacterDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;